import baseWs, {noAuthGetDownloadRequest, noTimeoutWs} from './baseWs'
import _ from 'lodash';
//import axios from 'axios';

/// To Add nre attachment
export function newAttachment() {
    return baseWs.post('/api/services/app/attachment/NewAtttachmentGuid')
    .then(res => {
        return res;
    })
    .catch(err => {
        if (!_.isEmpty(err.response)) {
            console.log('Error')
        }
        console.log('Error getting new attachment id: ' + err);
        throw err;
    });
}

export function getAttachmentList(sourceKey) {
    return baseWs.post('/api/services/app/attachment/GetAttachmentList', {
        sourceKey: sourceKey
    })
    .then(res => {
        return res;
    })
    .catch(err => {
        if (!_.isEmpty(err.response)) {
            console.log('Error')
        }
        console.log('Error getting attachment list: ' + err);
        throw err;
    });
}

///GetMaxAttachmentSizeAndMbByteCount
export function getMaxAttachmentSizeAndMbByteCount() {
    return baseWs.post('/api/services/app/attachment/GetMaxAttachmentSizeAndMbByteCount', {})
    .then(res => {
        return res;
    })
    .catch(err => {
        if (!_.isEmpty(err.response)) {
            console.log('Error')
        }
        console.log('Error getting max attachment size and Mb byte count: ' + err);
        throw err;
    });
}

export function updateAttachment(description, documentNumber, id, name, sourceKey) {
    return baseWs.post('/api/services/app/attachment/UpdateAttachment', {
        description: description, documentNumber: documentNumber, id: id, name: name, sourceKey:sourceKey
    })
    .then(res => {
        return res;
    })
    .catch(err => {
        if (!_.isEmpty(err.response)) {
            console.log('Error')
        }
        console.log('Error updating attachment: ' + err);
        throw err;
    });
}


export function deleteAttachment(id, sourceKey) {

	return baseWs.post('/api/services/app/attachment/DeleteAttachment', {
		id: id, sourceKey: sourceKey
	})
	.then(res => {
		return res;
	})
	.catch(err => {
		if (!_.isEmpty(err.response)) {
			console.log('Error')
		}
		console.log('Error deleting attachment: ' + err);
		throw err;
	});
}

// /api/attachment
export function addAttachment(sourceKey, contentType, name, description, attType,  data, tableName) {
	var payLoad = new FormData();
	payLoad.append("sourceKey", sourceKey);
	payLoad.append("contentType", contentType);
	payLoad.append("name", name);
	payLoad.append("description", description);
	payLoad.append("attType", attType);
	payLoad.append("file", data, name);
	payLoad.append("tableName", tableName);

	return noTimeoutWs.post('/api/attachment', payLoad) //Wrong needs to attach file to form data
	.then(res => {
		return res;
	})
	.catch(err => {
		if (!_.isEmpty(err.response)) {
			console.log('Error')
		}
		console.log('Error adding attachment: ' + err);
		throw err;
	});
}


///download Attachment
export function getAttachment(id, name, sourceKey) {
	return noTimeoutWs.post('/api/services/app/attachment/GetAttachment', { id: id, name: name, sourceKey: sourceKey})
	.then(res => {
		return res;
	})
	.catch(err => {
		if (!_.isEmpty(err.response)) {
			console.log('Error')
		}
		console.log('Error getting attachment: ' + err);
		throw err;
	});
}

///get Attachment download URL
export function getAttachmentDownloadUrl(id, name, sourceKey) {
	return baseWs.post('/api/services/app/attachment/GetAttachmentDownloadUrl', { id: id, name: name, sourceKey: sourceKey})
	.then(res => {
		return res;
	})
	.catch(err => {
		if (!_.isEmpty(err.response)) {
			console.log('Error')
		}
		console.log('Error getting attachment: ' + err);
		throw err;
	});
}

export function downloadFromUrl_GET(url){
	return noAuthGetDownloadRequest(url)
	.then(res => {
		return res;
	})
	.catch(err => {
		if (!_.isEmpty(err.response)) {
			console.log('Error')
		}
		console.log('Error getting attachment: ' + err);
		throw err;
	});
}

///Validate attachment
export function requiresAttachment(tableName, sourceKey) {
    return baseWs.post('/api/services/app/genericScreen/RequiresAttachments', { tableName: tableName, sourceKey: sourceKey})
    .then(res => {
        return res;
    })
    .catch(err => {
        if (!_.isEmpty(err.response)) {
            console.log('Error')
        }
        console.log('Error validating attachment attachment: ' + err);
        throw err;
    });
}


///Get table attachment
export function getTableAttachment(tableName) {
    return baseWs.post('/api/services/app/genericScreen/GetTableAttachment', { tableName: tableName})
    .then(res => {
        return res;
    })
    .catch(err => {
        if (!_.isEmpty(err.response)) {
            console.log('Error')
        }
        console.log('Error validating attachment attachment: ' + err);
        throw err;
    });
}